import {Card, Heading, Link, River, RiverBreakout, Section, SectionIntro, Text} from '@primer/react-brand'
import {Spacer, SectionVisual} from './_shared'

export default function Automation() {
  return (
    <Section id="automation">
      <SectionVisual visual="copilot" />

      <SectionIntro className="sh-SectionIntro" align="center" fullWidth>
        <SectionIntro.Heading as="h2" size="3">
          Accelerate performance
        </SectionIntro.Heading>

        <SectionIntro.Description>
          With Copilot embedded throughout the platform, you can simplify your toolchain, automate tasks, and improve
          the developer experience.
        </SectionIntro.Description>
      </SectionIntro>

      <Spacer size="40px" size1012="80px" />

      <RiverBreakout className="Automation-riverBreakout">
        <RiverBreakout.Visual className="Automation-riverBreakoutVisual">
          <div className="Automation-riverBreakoutVisualFrame">
            <img
              className="Automation-riverBreakoutVisualImage"
              src="/images/modules/site/home24/automation/breakout.webp"
              alt="TODO"
            />
          </div>
        </RiverBreakout.Visual>

        <RiverBreakout.Content
          className="Automation-riverBreakoutContent"
          trailingComponent={() => (
            <div className="Collaboration-riverBreakoutTrailingComponent">
              <Card
                className="Automation-card"
                ctaText="Read customer story"
                href="#TODO"
                hasBorder={false}
                disableAnimation={true}
              >
                <Card.Image
                  src="/images/modules/site/home24/automation/logo-duolingo.svg"
                  alt="Duolingo's logo"
                  height="32"
                />
                <Card.Description>Discover how Duolingo increased developer speed with Copilot</Card.Description>
              </Card>

              <hr className="Automation-cardHr" />

              <Card
                className="Automation-card"
                ctaText="Read the report"
                href="#TODO"
                hasBorder={false}
                disableAnimation={true}
              >
                <Card.Image
                  src="/images/modules/site/home24/automation/logo-gartner.svg"
                  alt="Gartner's logo"
                  height="24"
                />
                <Card.Description>2024 Gartner® Magic Quadrant™ for AI Code Assistants</Card.Description>
              </Card>
            </div>
          )}
        >
          <Text className="Automation-riverBreakoutContentText">
            <b>Work 55% faster.</b>
            <sup>1</sup> Increase performance with AI-powered coding assistance, including code completion, chat, and
            more.
          </Text>
          <Link href="#TODO">Explore GitHub Copilot</Link>
        </RiverBreakout.Content>
      </RiverBreakout>

      <River className="Automation-river">
        <River.Visual className="Automation-riverVisual">
          <img src="/images/modules/site/home24/automation/river-1.webp" alt="TODO" />
        </River.Visual>

        <River.Content className="Automation-riverContent">
          <Heading size="6">Automate any workflow</Heading>
          <Text size="300">Optimize your process with simple and secure CI/CD.</Text>
          <Link href="#TODO">Explore GitHub Actions</Link>
        </River.Content>
      </River>
    </Section>
  )
}

try{ Automation.displayName ||= 'Automation' } catch {}